import { Component, Input, HostBinding } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'arrow-icon',
  templateUrl: 'arrow-icon.component.html',
  styleUrls: ['arrow-icon.component.scss'],
})
export class ArrowIconComponent {
  @HostBinding('class.direction-up')
  @Input() up: boolean = false;

  @Input() colorName: string;

  get fill(): string {
    switch (this.colorName) {
      case 'blue':
        return '#016EE8';
      case 'white':
        return '#FFFFFF';
      default:
        return '#FFFFFF';
    }
  }
}
